module.exports = __webpack_public_path__ + "static/logo-1-1-e605d1b100fc956cc3ea8e1b34838496.png";